export default __webpack_public_path__ + "assets/NIAC-VC-talk.1cba3804.png";